import React from 'react'
import SelectInput from "components/inputs/selectInput"
import { useTranslation } from "react-i18next"
import TextInput from 'components/inputs/textInput'
import Collapse from 'components/collapse/Collapse'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import { SortDirection } from 'types'
import { ActionsSortBy } from 'hooks/useActions'
import InputGroup from '@/components/inputs/InputGroup'

interface ActionFilterProps {
    filterQuery: string,
    setFilterQuery: (str: string) => void,
    isLoading?: boolean
    allowedSortBy: string[],
    sortBy: string,
    setSortBy: (str: ActionsSortBy) => void,
    sortDirection: SortDirection,
    setSortDirection: (str: SortDirection) => void,
    typeFilter: string,
    setTypeFilter: (str: string) => void,
}

const ActionFilter: React.FC<ActionFilterProps> = ({
    filterQuery,
    setFilterQuery,
    isLoading,
    allowedSortBy,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    typeFilter,
    setTypeFilter,
}) => {

    const { t } = useTranslation()

    const handleFilterQueryChange = (str: string) => {
        setFilterQuery(str)
    }

    return (
        <div className="flex flex-col gap-y-4">
            <Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />}>
                <TextInput ignore={true} label={t('labelFilterQuery')} value={filterQuery} onChange={(e) => handleFilterQueryChange(e.target.value)} disabled={isLoading} />
                <InputGroup forcedColumns={true}>
                    {/* Type Filter Select */}
                    <SelectInput ignore={true} label={t('labelActionType')} value={typeFilter} onChange={e => setTypeFilter(e.target.value)} disabled={isLoading}>
                        <option value="all">{t('labelAll')}</option>
                        <option value="increment">{t('labelAdd')}</option>
                        <option value="decrement">{t('labelRemove')}</option>
                        <option value="adjust">{t('labelAdjust')}</option>
                    </SelectInput>
                    {/* Sort By Select */}
                    <SelectInput ignore={true} label={t('labelSortBy')} value={sortBy} onChange={e => setSortBy(e.target.value as ActionsSortBy)} disabled={isLoading}>
                        {allowedSortBy.map((field) => (
                            <option key={field} value={field}>{t(field)}</option>
                        ))}
                    </SelectInput>
                    {/* Sort Direction Select */}
                    <SelectInput ignore={true} label={t('labelSortDirection')} value={sortDirection} onChange={e => setSortDirection(e.target.value as SortDirection)} disabled={isLoading}>
                        <option value="asc">{t('labelAscending')}</option>
                        <option value="desc">{t('labelDescending')}</option>
                    </SelectInput>
                </InputGroup>
            </Collapse>
        </div>
    )
}

export default ActionFilter
